import React from "react";
import { FieldGroup } from "../../components";
import { Window } from "../../contexts";
import DataHelper from "../../helpers/Data";
import useCategories from "../../hooks/useCategories.js";

const BusinessFormForClient = ({ user, isProfile, isRC }) => {
  const isCreateForm = !user && !isProfile;
  const categoryOptions = useCategories();

  if (isCreateForm) {
    return (
      <div className="business-form business-form--client business-form--create">
        {/* Contact owner sits in the Overview head on create. */}
        <div className="row overview-form__row">
          <div className="col-md-6">
            <FieldGroup
              bare
              placeholder="Prospect"
              name="prospect_type"
              type="select"
              options={DataHelper.prospect_type}
              disabled={isRC}
            />
          </div>
        </div>

        <div className="row overview-form__row">
          <div className="col-md-6">
            <FieldGroup bare placeholder="Job Title" name="title" disabled={isRC} />
          </div>
          <div className="col-md-6">
            <FieldGroup bare placeholder="Company" name="company" disabled={isRC} />
          </div>
        </div>

        <div className="row overview-form__row">
          <div className="col-md-6">
            <FieldGroup
              bare
              placeholder="Company Url"
              name="company_url"
              disabled={isRC}
            />
          </div>
          <div className="col-md-6">
            <FieldGroup
              bare
              placeholder="Linkedin Url"
              name="linkedin_url"
              disabled={isRC}
            />
          </div>
        </div>

        <div className="row overview-form__row">
          <div className="col-md-6">
            <FieldGroup
              bare
              placeholder="Instagram Url"
              name="instagram_url"
              disabled={isRC}
            />
          </div>
        </div>

        {!isRC && (
          <div className="business-form__expertise">
            <FieldGroup
              bare
              label="Work experience"
              name="expert_categories"
              type="multiselect"
              maxSelections={2}
              options={categoryOptions}
              disabled={isRC}
              className="business-form__expertise-field rc-create-multiselect"
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="business-form business-form--client">
      {!isProfile && !user?.is_sales_admin && (
        <div className="row">
          <div className="col-md-6">
            <FieldGroup
              placeholder="Contact owner"
              type="select"
              name="owner_id"
              optionsUrl={`/api/users/sales-admins`}
              optionsMethod="post"
              defaultValue={user?.id}
              disabled={isRC}
            />
          </div>
          <div className="col-md-6">
            {user ? (
              <FieldGroup
                placeholder="Segmentation"
                name="segmentation"
                type="text"
                readOnly
                disabled={isRC}
              />
            ) : (
              <FieldGroup
                placeholder="Prospect"
                name="prospect_type"
                type="select"
                options={DataHelper.prospect_type}
                disabled={isRC}
              />
            )}
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-md-6">
          <FieldGroup placeholder="Job Title" name="title" disabled={isRC} />
          <FieldGroup
            placeholder="Company Url"
            name="company_url"
            disabled={isRC}
          />
          <FieldGroup
            placeholder="Instagram Url"
            name="instagram_url"
            disabled={isRC}
          />
        </div>

        <div className="col-md-6">
          <FieldGroup placeholder="Company" name="company" disabled={isRC} />
          <FieldGroup
            placeholder="Linkedin Url"
            name="linkedin_url"
            disabled={isRC}
          />
        </div>
      </div>

      {!isRC && (
        <div className="business-form__expertise">
          <FieldGroup
            label="Work expertise"
            name="expert_categories"
            type="multiselect"
            maxSelections={2}
            options={Window.CATEGORIES}
            disabled={isRC}
          />
        </div>
      )}
    </div>
  );
};

export default BusinessFormForClient;
